import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=fa401f1a&scoped=true"
import script from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=fa401f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa401f1a",
  null
  
)

export default component.exports